import { darken, transparentize } from "polished";
import { createGlobalStyle } from "styled-components";
import "react-datepicker/dist/react-datepicker.css";

export const GlobalStyle = createGlobalStyle`
html,
body,
#root {
  height: 100%;
  min-height: 100%;
}

html {
  font-size: 80%;
  overflow-y: scroll;
  @media(min-width: ${(props) => props.theme.breakpoints.sm}) {
    font-size: 100%;
  }
}

body {
  background-color: ${(props) => darken(0.02, props.theme.colors.background)};
}

body, button {
  font-family: ${(props) => props.theme.fonts.body};
  font-size: ${(props) => props.theme.baseFontSize}px;
  line-height: ${(props) => props.theme.baseLineHeight};
  padding: 0;
  margin: 0;
  color: ${(props) => props.theme.colors.body};
}

h1,
h2,
h3,
h4,
h5,
h6,
pre,
p {
  margin: 0;
  font-family: ${(props) => props.theme.fonts.body};
    font-size: ${(props) => props.theme.baseFontSize}px;
  line-height: ${(props) => props.theme.baseLineHeight};
  font-weight: normal;
}

*,
*:before,
*:after {
  box-sizing: border-box;
}

a {
  color: ${(props) => props.theme.colors.primary};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

}

  .StripeElement {
    background: rgba(0,0,0,0);
    border: 0;
    border-bottom: 1px solid ${(props) => props.theme.colors.grey3};
    width: 100%;
    display: block;
    color: ${(props) => props.theme.colors.body};
    box-shadow: none;
    border-radius: 0;

    &--focus {
      outline: 0;
      border-bottom: 1px solid ${(props) => props.theme.colors.primary};
    }

    &::placeholder {
      font-size: 12px;
      color: #aaa;
    }
  }

  .react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected, .react-datepicker__quarter-text--keyboard-selected, .react-datepicker__year-text--keyboard-selected {
    background-color: ${(props) => props.theme.colors.primary};
  }

  .react-datepicker {
    font-family: ${(props) => props.theme.fonts.body};
    background-color: ${(props) => props.theme.colors.background};
    border: 0;
    box-shadow: ${(props) => props.theme.shadows[2]};
  }

  .react-datepicker__navigation {
    top: 16px;
  }

  .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range), .react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range), .react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range), .react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range) {
    background-color: ${(props) =>
      transparentize(0.5, props.theme.colors.primary)};
  }

  .react-datepicker__day:hover, .react-datepicker__month-text:hover, .react-datepicker__quarter-text:hover, .react-datepicker__year-text:hover {
    background-color: ${(props) => props.theme.colors.grey2};
  }

  .react-datepicker__day-name, .react-datepicker__day, .react-datepicker__time-name {
    color: ${(props) => props.theme.colors.body};
  }
  .react-datepicker__current-month, .react-datepicker-time__header, .react-datepicker-year-header {
    
    color: ${(props) => props.theme.colors.body};
  }
  .react-datepicker__header {
    background-color: ${(props) => props.theme.colors.grey0};
  }
  .react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range, .react-datepicker__month-text--selected, .react-datepicker__month-text--in-selecting-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--selected, .react-datepicker__quarter-text--in-selecting-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--selected, .react-datepicker__year-text--in-selecting-range, .react-datepicker__year-text--in-range {
    color: white;
    background-color: ${(props) => props.theme.colors.primary};
  }
`;

export default GlobalStyle;
